/**
 * Laravel request()->bearerToken() matches "Bearer " case-sensitively.
 * Always send this scheme on MouseWait backend Authorization headers.
 */
export const LOUNGE_BEARER_SCHEME = 'Bearer';

export const isRealLoungeAccessToken = (
  token: string | null | undefined
): token is string => Boolean(token) && token !== 'null' && token !== 'undefined';

export const formatLoungeBearerAuthorization = (token: string): string =>
  `${LOUNGE_BEARER_SCHEME} ${token}`;

export const buildLoungeAuthHeaders = (
  token: string | null | undefined
): Record<string, string> => {
  if (!isRealLoungeAccessToken(token)) {
    return {};
  }
  return { Authorization: formatLoungeBearerAuthorization(token) };
};
